require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/fn/symbol/iterator.js
// module id = 282
// module chunks = 16